module.exports = __webpack_public_path__ + "img/genre_dj_dance.8e5a44a3.png";